export enum InputValidationDebounce {
  Default = 600
}
